import styled, { css } from 'styled-components';
import { Form } from '@unform/web';

interface StatuProps {
  status: string;
}

export const Container = styled.div`
  flex: 1;
  display: flex;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // margin-top: 3.42rem;
  // margin-left: 4.4rem;
	padding: 3.9rem 1.5rem 5rem 5.5rem; // 4.42rem 1.5rem 5rem 5.5rem;

	// 767px
  @media (max-width: 47.9375rem) {
    margin-left: 0;
		padding: 4.3rem 0.5rem 5rem;
  }
`;

export const Filtros = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
	padding: 5px 10px 10px;
	box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
	border-radius: 8px;

	// 479px
  @media (max-width: 29.9375rem) {
		width: 100%;
		padding: 5px 0 10px;
	}
`;

export const FormView = styled(Form)`
  display: flex;
  align-items: center;
	// border: 2px solid blue;

	.input-content {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		width: 100%;

		margin-right: 10px;

		:last-child {
			margin-right: 0;
		}

		span {
			font-size: 0.9375rem; // 15px
			font-weight: 500;
			color: #455a64;
		}
	}

	.input-content-button {
		margin-left: 10px;
	}

	button {
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #1a83ff;
		color: #fff;
		font-weight: 600;
		border-radius: 8px;
		padding: 7px 30px;

		svg {
			font-size: 20px;
			margin-right: 10px;
		}
	}

	// 479px
  @media (max-width: 29.9375rem) {
		flex-direction: column;
		width: 100%;
		margin: 0 5px;

		.input-content {
			div {
				padding: 2px 5px !important;

				input {
					font-size: 13px;
				}
			}
		};
		.input-content-button {
			margin-top: 5px;

			span {
				visibility: hidden;
				display: none;
			}
		};

		button {
			font-size: 13PX;
			padding: 9px 20px;

			svg {
				font-size: 18px;
			}
		};
	}
`;

export const ListVazio = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;

export const Status = styled.span<StatuProps>`
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;

  ${props =>
    props.status === 'CANCELADO'
      ? css`
          color: #b71c1c;
        `
      : props.status === 'CONCLUÍDO'
      ? css`
          color: #1b5e20;
        `
      : props.status === 'CONFIRMADA'
      ? css`
          color: #1b5e20;
        `
      : props.status === 'COM ENTREGADOR'
      ? css`
          color: #1a83ff;
        `
      : props.status === 'EM PREPARO'
      ? css`
          color: #1a83ff;
        `
      : css`
          color: #ff6f00;
        `}
`;
